module.exports = `${require.publicPath}earth-img01.d6035c00.png`;